import dayjs from "dayjs";

export const obtenerDiasFaltantes = ({bolsillo}) =>{


    let hoy = dayjs();
    let dias = bolsillo.numMeses

    let fechainicio = dayjs(bolsillo.fecha)

    let fechaMeta = fechainicio.add(dias, 'month')
    const diasCompletos = fechaMeta.diff(hoy, 'day');

    return diasCompletos;

}